export default `
  <div class="wb-doc-page">
    <div class="doc-text doc-pt16">基于实现在用户身份认证、手机设备安全、接收信息推送、登录第三方服务、通过第三方平台分享信息以及保障交易安全的需要，在向您提供服务过程中，盈宝证券会与第三方共享信息，我们将这些第三方服务商的名称、使用目的、官网链接分别列明如下。</div>

    <div class="doc-main-title">一、分享类</div>

    <div class="doc-text">1. 微信开放平台</div>
    <div class="doc-text">来源：深圳市腾讯计算机系统有限公司</div>
    <div class="doc-text">使用目的：帮助用户使用微信分享功能</div>
    <div class="doc-text">官网链接：https://open.weixin.qq.com</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</div>

    <div class="doc-text">2. 新浪微博开放平台</div>
    <div class="doc-text">来源：北京微梦创科网络技术有限公司</div>
    <div class="doc-text">使用目的：帮助用户使用微博分享功能</div>
    <div class="doc-text">官网链接：https://open.weibo.com</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://weibo.com/signup/v5/privacy?spm=a1zaa.8161610.0.0.4f8776217Wu8R1</div>

    <div class="doc-text">3. QQ互联</div>
    <div class="doc-text">来源：深圳市腾讯计算机系统有限公司</div>
    <div class="doc-text">使用目的：帮助用户使用QQ账号的分享功能</div>
    <div class="doc-text">官网链接：https://open.tencent.com</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://wiki.connect.qq.com/QQ互联SDK隐私保护声明</div>

    <div class="doc-text">4. Facebook分享</div>
    <div class="doc-text">来源：Facebook</div>
    <div class="doc-text">使用目的：帮助用户使用Facebook的分享功能</div>
    <div class="doc-text">官网链接：https://developers.facebook.com</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://www.facebook.com/privacy/explanation</div>

    <div class="doc-text">5. TwitterKit</div>
    <div class="doc-text">来源：Twitter</div>
    <div class="doc-text">使用目的：帮助用户使用Twitter的分享功能</div>
    <div class="doc-text">官网链接：https://github.com/twitter-archive/twitter-kit-ios</div>
    <div class="doc-text doc-pb28">隐私政策链接：无</div>

    <div class="doc-text">6. shareSDK</div>
    <div class="doc-text">来源：上海游昆信息技术有限公司</div>
    <div class="doc-text">使用目的：帮助用户使有各社交平台分享功能</div>
    <div class="doc-text">官网链接：https://www.mob.com</div>
    <div class="doc-text">隐私政策链接：https://www.mob.com/about/policy</div>

    <div class="doc-main-title">二、推送类</div>

    <div class="doc-text">1. Google推送</div>
    <div class="doc-text">来源：Google</div>
    <div class="doc-text">使用目的：向使用支持google服务设备的用户进行消息推送</div>
    <div class="doc-text">官网链接：https://firebase.google.com/docs/cloud-messaging</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://firebase.google.com/support/privacy?hl=zh-cn</div>

    <div class="doc-text">2. 极光推送</div>
    <div class="doc-text">来源：深圳市和讯华谷信息技术有限公司</div>
    <div class="doc-text">使用目的：向用户发送离线消息推送</div>
    <div class="doc-text">官网链接：https://www.jiguang.cn</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://www.jiguang.cn/license/privacy</div>

    <div class="doc-text">3. 小米推送</div>
    <div class="doc-text">来源：小米科技有限责任公司</div>
    <div class="doc-text">使用目的：向用户发送离线消息推送</div>
    <div class="doc-text">官网链接：https://dev.mi.com/platform</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://dev.mi.com/console/doc/detail?pId=1822</div>

    <div class="doc-text">4. 华为推送</div>
    <div class="doc-text">来源：华为技术有限公司</div>
    <div class="doc-text">使用目的：向用户发送离线消息推送</div>
    <div class="doc-text">官网链接：https://developer.huawei.com/consumer/cn/appgallery/</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://developer.huawei.com/consumer/cn/doc/app/20213#h1-1636428705592-2</div>

    <div class="doc-text">5. 荣耀推送</div>
    <div class="doc-text">来源：荣耀终端有限责任公司</div>
    <div class="doc-text">使用目的：向用户发送离线消息推送</div>
    <div class="doc-text">官网链接：https://developer.hihonor.com/cn</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://www.hihonor.com/cn/privacy/privacy-policy/</div>

    <div class="doc-text">6. OPPO推送</div>
    <div class="doc-text">来源：广东欧珀移动通信有限公司</div>
    <div class="doc-text">使用目的：向用户发送离线消息推送</div>
    <div class="doc-text">官网链接：https://open.oppomobile.com</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://open.oppomobile.com/new/developmentDoc/info?id=11139</div>

    <div class="doc-text">7. 魅族推送</div>
    <div class="doc-text">来源：珠海市魅族科技有限公司</div>
    <div class="doc-text">使用目的：向用户发送离线消息推送</div>
    <div class="doc-text">官网链接：http://open.flyme.cn/</div>
    <div class="doc-text">隐私政策链接：https://open.flyme.cn/docs?id=202</div>

    <div class="doc-main-title">三、支付类</div>

    <div class="doc-text">1. Google Pay</div>
    <div class="doc-text">来源：Google</div>
    <div class="doc-text">使用目的：为用户提供Google Pay支付服务</div>
    <div class="doc-text">官网链接：https://developers.google.com/identity/sign-in/android/</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://policies.google.com/privacy</div>

    <div class="doc-text">2. Apple pay</div>
    <div class="doc-text">来源：Apple</div>
    <div class="doc-text">使用目的：为用户提供Apple Pay支付服务</div>
    <div class="doc-text">官网链接：https://www.apple.com</div>
    <div class="doc-text">隐私政策链接：https://www.apple.com/legal/privacy/en-ww/</div>

    <div class="doc-main-title">四、其他类</div>

    <div class="doc-text">1. IM SDK</div>
    <div class="doc-text">来源：北京易掌云峰科技有限公司</div>
    <div class="doc-text">使用目的：为用户提供即时通信功能</div>
    <div class="doc-text">官网链接：https://www.easemob.com/</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://www.easemob.com/protocol</div>

    <div class="doc-text">2. Bugly</div>
    <div class="doc-text">来源：深圳市腾讯计算机系统有限公司</div>
    <div class="doc-text">使用目的：帮助开发人员定位用户使用App过程中的闪退问题</div>
    <div class="doc-text">官网链接：https://bugly.qq.com/</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf</div>

    <div class="doc-text">3. 阿里云OSS、文本内容审查、MSM</div>
    <div class="doc-text">来源：阿里云计算有限公司</div>
    <div class="doc-text">使用目的：对用户头像及反馈图片储存、敏感内容审查、发送短信的服务</div>
    <div class="doc-text">官网链接：https://www.aliyun.com/</div>
    <div class="doc-text doc-pb28">隐私政策链接：http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.19720258.J_9220772140.87.e9392c4a3upEEK</div>

    <div class="doc-text">4. 腾讯OCR</div>
    <div class="doc-text">来源：腾讯云计算（北京）有限责任公司</div>
    <div class="doc-text">使用目的：为用户提供身份信息识别服务</div>
    <div class="doc-text">官网链接：https://cloud.tencent.com</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://cloud.tencent.com/document/product/301/11470</div>

    <div class="doc-text">5. 友盟+</div>
    <div class="doc-text">来源：北京锐讯灵通科技有限公司、友盟同欣（北京）科技有限公司</div>
    <div class="doc-text">使用目的：统计分析及应用性能监测</div>
    <div class="doc-text">官网链接：https://www.umeng.com</div>
    <div class="doc-text doc-pb28">隐私政策链接：https://www.umeng.com/page/policy</div>
  </div>
`
